// extracted by mini-css-extract-plugin
export default {"container":"JiyqX6","contentWrapper":"lnx4Ue","divider":"HQQeZs","domainInput":"XkvN8w","templateFooter":"akWni3","textDisclaimer":"jFNBmX"};